import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { userSchemaObject } from '../../Data';
import { Fields, validateProperty, validate, Card } from "../../Common";
import MessageModal from '../../../UI/Modal/MessageModal';
import { packagePasswordResetSchemaObject } from '../packageCreationSchema';
import { PageHeader } from '../../../Common';
import Joi from '@hapi/joi';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import tokenDecoder from '../../../Common/tokenDecoder'

export function PacakgePasswordChange(props) {
    const { data, edit } = props.location ?? props;
    const [pageProperties, setPageProperties] = useState({
        title: 'Password Reset',
        submitButtonName: 'Reset',
        passwordFieldDisabled: false
    })
    const [errors, setErrors] = useState({})
    const [packagePasswordChange, setPackagePasswordChange] = useState({
        packageName: "",
        newPassword: "",
        confirmPassword: ""

    });
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })
    const [isOldPasswordHidden, setIsOldPasswordHidden] = useState(false);
    const [isBackHidden, setIsBackHidden] = useState(true);
    const [password, setPassword] = useState({});
    const [currentUserDetails, setCurrentUserDetails] = useState({});
    const schema = Joi.object(packagePasswordResetSchemaObject).options({ allowUnknown: true })
    const [packageName, setPackageName] = useState({});


    useEffect(() => {
        setPageProperties({
        title: 'Reset Password',
        submitButtonName: 'Reset Password'
         })
        if(packageName !=null){
        setPackagePasswordChange({
         ...packagePasswordChange,
        packageName: data.packageName,
         })
        }
        setCurrentUserDetails(tokenDecoder.getUserDetailsFromToken());
         }, [])


    function handleChange(e) {
        const target = e.target

        const value = (target.name === 'isActive' || target.name === 'isLocked') ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, packagePasswordResetSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setPackagePasswordChange({
            ...packagePasswordChange,
            [e.target.name]: value
        })
        setErrors(error)
    }




    async function handleSave(e) {
        e.preventDefault()
        const target = e.target

        if (packagePasswordChange.newPassword === packagePasswordChange.confirmPassword) {
            setPassword(packagePasswordChange.confirmPassword);


            const errorMessages = validate(schema, packagePasswordChange)
            errorMessages !== null ? setErrors(errorMessages) : setErrors({})
            let passwordFlag = false

            if (errorMessages != null) {
                var array = Object.keys(errorMessages);

                if (array.length === 1 && array.indexOf("oldPassword") === 0) {
                    passwordFlag = true;
                }
            }


            if (errorMessages && !passwordFlag && edit) {
                return
            }


            setErrors(errors)

            saveData();
        }
        else {
            setMessageModel({ ...messageModel, hidden: false, type: "Error", disciption: "Password mismatch" })
            setPackagePasswordChange({
                ...packagePasswordChange,
                confirmPassword: ""
            })
            setTimeout(() => {
                modalDismissHandler();
            }, 1500);
            return null;
        }
    }

    function logoutHandler() {
        window.logout.logout();
    }

    async function saveData() {        
            const response = await services.passwordReset(data.packageID, packagePasswordChange.confirmPassword);
            if (response.statusCode === "Success") {
                setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
                afterSuccessfulyReset(response.statusCode)
            }
            else {
                setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
            }
        
    }

    function afterSuccessfulyReset(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/packagecreation' })
            }, 1500);
        }
        clearState();
        //window.logout = functionsWindow;
    }


    function clearState() {

        setPackagePasswordChange({
            ...packagePasswordChange,
            newPassword: "",
            confirmPassword: ""
        })
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function setMessage(hidden, type, status) {
        setMessageModel({ ...messageModel, hidden: hidden, type: type, disciption: status })
    }

    function onCancelClick() {
        clearState();
        setErrors({});
    }
    function keyDown(e) {
        var e = window.event || e;
        var key = e.keyCode;
        if (key == 32) {
            e.preventDefault();
        }
    }

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-12">

                    <div className="card">
                        <PageHeader
                            title={pageProperties.title}
                            isButtonEnable={isBackHidden}
                            buttonText="Back to Listing"
                            path="/users"
                        />


                        <form onSubmit={(e) => handleSave(e)}>
                            <div className="card-body">

                                <div className="form-group row">

                                    <div className="col-md">
                                        <InputLabel shrink id="packageName">Package Name *</InputLabel>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            name="packageName"
                                            id="packageName"
                                            onChange={(e) => handleChange(e)}
                                            value={packagePasswordChange.packageName}
                                            maxLength={12}
                                            onKeyDown={(e) => keyDown(e)}
                                            disabled={true}
                                        />
                                        {errors["packageName"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["packageName"]}</FormHelperText>}

                                    </div>

                                    <div className="col-md">
                                        <InputLabel shrink id="newPassword">New Password *</InputLabel>
                                        <TextField
                                            fullWidth
                                            type="password"
                                            name="newPassword"
                                            id="newPassword"
                                            onChange={(e) => handleChange(e)}
                                            value={packagePasswordChange.newPassword}
                                        />
                                        {errors["newPassword"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["newPassword"]}</FormHelperText>}

                                    </div>

                                    <div className="col-md">
                                        <InputLabel shrink id="confirmPassword">Confirm Password *</InputLabel>
                                        <TextField
                                            fullWidth
                                            type="password"
                                            name="confirmPassword"
                                            id="confirmPassword"
                                            onChange={(e) => handleChange(e)}
                                            value={packagePasswordChange.confirmPassword}
                                        />
                                        {errors["confirmPassword"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["confirmPassword"]}</FormHelperText>}

                                    </div>


                                </div>


                            </div>

                            <MessageModal
                                hidden={messageModel.hidden}
                                messageType={messageModel.type}
                                messageDescription={messageModel.disciption}
                                clicked={modalDismissHandler}
                            />


                            <div className="card-footer">
                                <input
                                    type="submit"
                                    className="btn btn-primary"
                                    value={pageProperties.submitButtonName}
                                    onClick={handleSave}
                                />
                                <input
                                    type="reset"
                                    className="btn btn-warning pull-right"
                                    value="Clear"
                                    onClick={onCancelClick}
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}